// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * Flare API
 * API for Flare learning platform
 * OpenAPI spec version: 0.1.0
 */

export type SubmissionFeedbackAnyOf = { [key: string]: unknown };
